export const qualities = ['E+', 'E', 'A+', 'A', 'B'] as const

export type QualityType = (typeof qualities)[number]

export type Qualities = {
  qualities: {
    [key in QualityType]: string
  }
}
